<template>
  <div class="home container">

<div class="justify-content-center">
      <h2 class="text-center">PartnersLife Brochures</h2>
      <h4 class="text-center mt-5">Visit PartnersLife website</h4>
      <div class="pdf-box">
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <a href="https://quote.partnerslife.co.nz/quote/life/pub/login?redirectTo=%2Fapp%2Fapplications%2Fsearch"><h4>PartnersLife</h4></a>
            </div>
            <div class="col-md-5 row">
            </div>
        </div>
      </div>


      <h4 class="text-center mt-5">Download PartnersLife Brochures</h4>
      <div class="pdf-box">
        <!-- 1-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Accidental Death')" ><h4>Accidental Death <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Business Protection Plan')" ><h4>Business Protection Plan <br />[ PDF ]</h4></a>
            </div>
           
        </div>
        <!-- 2-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Funeral Plan')" ><h4>Funeral Plan <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Hospital Cash Cover')" ><h4>Hospital Cash Cover <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 3-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Household Expenses')" ><h4>Household Expenses <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Income Cover')" ><h4>Income Cover <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 4-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Interim Cover')" ><h4>Interim Cover <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Life Cover (1)')" ><h4>Life Cover <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 5-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Life Income Cover')" ><h4>Life Income Cover <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Mortgage Repayment Cover')" ><h4>Mortgage Repayment Cover <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 6-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Partners Legacy Gift Plan')" ><h4>Partners Legacy Gift Plan <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Partners Protection Plan')" ><h4>Partners Protection Plan <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 7-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Premium Cover (1)')" ><h4>Premium Cover <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Private Medical Cover')" ><h4>Private Medical Cover <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 8-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Severe Trauma Cover')" ><h4>Severe Trauma Cover <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Specific Condition Cover')" ><h4>Specific Condition Cover <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 9-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Terminal Illness Cover')" ><h4>Terminal Illness Cover <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Total and Permanent Disability Cover')" ><h4>Total and Permanent Disability Cover <br />[ PDF ]</h4></a>
            </div>
        </div>
        <!-- 10-->
        <div class="row justify-content-center ">
            <div class="col-md-5 row">
              <i class="icon fas fa-file-pdf"></i>
              <a href="#" v-on:click="openFile('Overview - Trauma Cover')" ><h4>Trauma Cover <br />[ PDF ]</h4></a>
            </div>
            <div class="col-md-5 row">
            </div>
        </div>
      </div>
    </div>

  

  </div>
</template>

<script>
// @ is an alias to /src
import {mapState,mapMutations} from 'vuex';
import axios from 'axios'
//import pdfFile from '../assets/partnerslife_pdf/Overview-AccidentalDeath.pdf';
export default {
  name: 'PartnersLife',
  data(){
    return{
      
    }
  },
  components: {
  },
  computed:{
   ...mapState(['token'])
  },
  methods:{
      ...mapMutations(['setLogIn','checkLogIn']),  
      openFile(name){
        axios('./assets/partnerslife_pdf/'+name+'.pdf', {
            method: 'GET',
            responseType: 'blob'
        })
        .then(response => {
            //Create a Blob from the PDF Stream
            const file = new Blob(
            [response.data], 
            {type: 'application/pdf'});
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
        })
        .catch(error => {
            console.log(error);
        });
      }    
      

  },
  created(){
  
      
  }
}
</script>
<style>
.container {
background-color: var(--Color-main-gray-1);
margin:auto;
width: 80%!important;
padding:15px;
border-radius: 10px;
}
img{
  max-width: 200px!important;
}
.pdf-box{
  border: 1px solid;
  border-radius: 10px;
  color: #548F93;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 5px;
}
.pdf-box a{
  margin-top: 10px;
  margin-left: 10px;
}
.icon{
  font-size: 3.5rem;
  color: #548F93;
  margin-top: 1rem;
}
</style>